import { render, staticRenderFns } from "./landlordEvaluate.vue?vue&type=template&id=6777304c&scoped=true&"
import script from "./landlordEvaluate.vue?vue&type=script&lang=js&"
export * from "./landlordEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./landlordEvaluate.vue?vue&type=style&index=0&id=6777304c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777304c",
  null
  
)

export default component.exports